import { css } from '@linaria/atomic';

export type TextSize = 'large' | 'medium' | 'small' | 'inherit';

export type { TextAlignment } from '../../helpers/text-align.linaria';
import { theme } from '@frontend/theme';

export type FontWeight = 'regular' | 'bold' | 'inherit' | 'light' | 'medium' | 'semibold';

export const textBaseStyle = css`
  font-family: ${theme.font.family};
  line-height: ${theme.font.lineHeight};
  margin: 0;
`;

const TEXT_SIZE_CLASS: Record<TextSize, string> = {
  large: css`
    font-size: ${theme.font.size.large};
  `,
  medium: css`
    font-size: ${theme.font.size.medium};
  `,
  small: css`
    font-size: ${theme.font.size.small};
  `,
  inherit: css`
    font-size: inherit;
  `,
};

export const getTextSizeClassName = (size: TextSize) => TEXT_SIZE_CLASS[size];

const TEXT_WEIGHT_CLASS: Record<FontWeight, string> = {
  regular: css`
    font-weight: ${theme.font.weight.regular};
  `,
  light: css`
    font-weight: ${theme.font.weight.regular};
  `,
  medium: css`
    font-weight: ${theme.font.weight.regular};
  `,
  semibold: css`
    font-weight: ${theme.font.weight.semibold};
  `,
  bold: css`
    font-weight: ${theme.font.weight.bold};
  `,
  inherit: css`
    font-weight: inherit;
  `,
};

export const getTextWeightClassName = (weight: FontWeight) => TEXT_WEIGHT_CLASS[weight];
